// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"Toolbar_toolbar__otajl","toolbarGroup":"Toolbar_toolbarGroup__15mJA","toolbarLabel":"Toolbar_toolbarLabel__38QX7","label":"Toolbar_label__18JRL"};